import React, { useState } from "react";

const RandomPatientId = ({ sitePatients }) => {
  const [showModal, setShowModal] = useState(false);
  const [randomId, setRandomId] = useState("");

  const handleRandomIdClick = () => {
    const eligiblePatients = sitePatients.filter((p) => p.status === "Eligible");
    if (eligiblePatients.length > 0) {
      const randomPatient =
        eligiblePatients[Math.floor(Math.random() * eligiblePatients.length)];
      setRandomId(randomPatient.patientId);
    } else {
      setRandomId("No eligible patients available");
    }
    setShowModal(true);
  };

  return (
    <div>
      {/* Trigger Button */}
      <button
        onClick={handleRandomIdClick}
        className="btn btn-success d-flex"
        style={{ backgroundColor: "#278DDB", borderColor: "#28a745" }}
      >
      Random Patient ID
      </button>

      {/* Modal */}
      {showModal && (
        <div
          className="modal-overlay moday-overlay-custom"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // dark overlay
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="modal-content"
            style={{
              width: "500px",
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "12px",
              border: "2px solid #FFFFFF", // outline border
              boxShadow: "0 5px 15px rgba(0, 0, 0, 0.3)",
            }}
          >
            <h2
              className="text-xl font-bold mb-4 pb-2"
              style={{
                color: "#278DDB",
                borderBottom: "2px solid #278DDB",
                
              }}
            >
              Random Patient ID
            </h2>

            <p className="mb-2">The randomly selected patient ID is:</p>
            <p className="text-2xl font-bold text-black mb-4">{randomId}</p>

            <p className="text-sm text-gray-700 mb-6">
              Please note down this patient ID for double abstraction.
            </p>

            <div className="text-right">
              <button
                onClick={() => setShowModal(false)}
                className="btn btn-success"
                style={{
                  backgroundColor: "#278DDB",
                  borderColor: "#28a745",
                  padding: "6px 18px",
                  borderRadius: "6px",
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RandomPatientId;
